export default __webpack_public_path__ + "static/media/05.dbd0f9f4.png";